// Transitions
export const AHOC_FORM_VALID_TRANSITION_INCIDENT_DETAILS =
  "allsureHomeClaim/transition/incidentDetails/formValid";
export const AHOC_FORM_INVALID_TRANSITION_INCIDENT_DETAILS =
  "allsureHomeClaim/transition/incidentDetails/formInvalid";

export const transitionIncidentDetails = {
  formValid: () => ({ type: AHOC_FORM_VALID_TRANSITION_INCIDENT_DETAILS }),
  formInvalid: () => ({ type: AHOC_FORM_INVALID_TRANSITION_INCIDENT_DETAILS }),
};

// Input feild actions
export const AHOC_INCIDENT_DETAILS =
  "allsureHomeClaim/incidentDetails/";
export const AHOC_INCIDENT_DETAILS_SET_VALUE =
AHOC_INCIDENT_DETAILS+"setValue/";
export const AHOC_INCIDENT_DETAILS_SET_VALID =
AHOC_INCIDENT_DETAILS +"setValid/";
// export const PERSONAL_DETAILS_EDIT =
// AHOC_INCIDENT_DETAILS +"setEdit";

// export const TOOGLE_INSURANCE_TYPE_PRIVACY_NOTICE =
// ALLSURE_INSURANCE_INSURANCE_TYPE+"toogle/privacyNotice";

// export const  tooglePrivacyNotice=(value)=>({type: TOOGLE_INSURANCE_TYPE_PRIVACY_NOTICE, value})
export const setAhocIncidentDetailsValue =(value)=>({type: AHOC_INCIDENT_DETAILS_SET_VALUE, value})
export const setAhocIncidentDetailsFieldValid =(error,fieldType)=>({type: AHOC_INCIDENT_DETAILS_SET_VALID, error, fieldType})
// export const setPersonalDetailsEdit =(value)=>({type: PERSONAL_DETAILS_EDIT, value})



export const AHOC_INCIDENT_DETAILS_SET_VALUE_WITHOUT_VALIDATION =
AHOC_INCIDENT_DETAILS+"withoutValiddation/setValue";
export const setAhocInidentDetailsWithoutValidation =(value)=>({type: AHOC_INCIDENT_DETAILS_SET_VALUE_WITHOUT_VALIDATION, value})
